import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { gql } from '@/__generated__/index.ts';

const StreamSubscriptionUpdateMutation = gql(`
  mutation StreamSubscriptionUpdate($streamId: ID!, $customTargetsCheckoutData: CustomTargetsCheckoutData!) {
    streamSubscriptionUpdate(streamId: $streamId, customTargetsCheckoutData: $customTargetsCheckoutData)
  }
`);

export const useUpdateStreamSubscription = (streamId: string) => {
  const toast = useToast();

  const [mutate, result] = useMutation(StreamSubscriptionUpdateMutation, {
    onCompleted: () => {
      toast.success({
        title: 'Targets limit successfully updated',
      });
    },
    onError: (e) => {
      toast.error({
        title: 'Failed to update targets limit',
        subTitle: e.message,
      });
    },
    // Evict so every active query consuming the subscription refetches it
    update: (cache, { data }) => {
      if (data?.streamSubscriptionUpdate) {
        cache.evict({
          id: cache.identify({ __typename: 'Stream', id: streamId }),
          fieldName: 'subscription',
        });
        cache.gc();
      }
    },
  });

  const updateSubscription = (quantity: number) => {
    return mutate({
      variables: {
        streamId,
        customTargetsCheckoutData: { quantity },
      },
    });
  };

  return [updateSubscription, result] as const;
};
